import icon from 'assets/icons/calendar.png';

export default function CalendarIcon({ size = 24 }) {
  return <img src={icon} alt='Calendar' width={size} height={size} />;
}
